import {
  createActions,
  createReqConsts,
  createReqWatcher,
  createReqReducer,
} from '../../../utils/redux';

export const consts = createReqConsts('appointment-form', 'get-copay');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'unscheduled',
    'cost',
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/fetch-copay.js